import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Col, Row } from 'reactstrap';
import classNames from 'classnames';
import ViewServiceEntryOverlay from '../../ServiceEntries/ViewServiceEntryOverlay';
import Signals from '../../../../signals/Signals';
import DetailServiceEntryStatusComponent from '../../ServiceEntries/DetailServiceEntryStatusComponent';
import DateTime from "../../../components/ui/DateTime/DateTime";
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
export default function AssetServiceEntryRow(props) {
    var serviceEntryModel = props.serviceEntryModel;
    if (!serviceEntryModel) {
        return;
    }
    var classes = classNames({ 'asset-service-entry-row py-3 w-100 border-bottom': true }) + ' ' + props.className;
    return React.createElement("div", { className: classes },
        React.createElement(Row, { className: "row w-100" },
            React.createElement(Col, { sm: 12 }, serviceEntryModel.name)),
        React.createElement(Row, { className: "row w-100" },
            React.createElement(Col, { sm: 12, className: "text-muted" },
                serviceEntryModel.description,
                serviceEntryModel.assetValueOnClose > 0 &&
                    React.createElement("div", { className: "d-inline" },
                        React.createElement("span", { className: "mx-2" }, "|"),
                        React.createElement(FormattedMessage, { id: "page.service.entries.table.column.valueonclose" }),
                        ": ",
                        React.createElement(FormattedNumber, { value: serviceEntryModel.assetValueOnClose, style: "unit", unit: "hour", minimumFractionDigits: 1, maximumFractionDigits: 1 })))),
        React.createElement(Row, { className: "row w-100 mt-2" },
            React.createElement(Col, null,
                React.createElement(FormattedMessage, { id: "page.service.entries.table.column.created" }),
                ": ",
                React.createElement(DateTime, { relativeTimeClasses: "text-muted", date: serviceEntryModel.creationDateTimeUtc, hideTime: true }))),
        React.createElement(Row, { className: "row w-100 mt-2" },
            React.createElement(Col, { sm: 12 },
                React.createElement(DetailServiceEntryStatusComponent, { serviceEntryModel: serviceEntryModel }))),
        React.createElement(Row, { className: "justify-content-end w-100" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: function () {
                    Signals.ShowOverlay.dispatch(React.createElement(ViewServiceEntryOverlay, { serviceEntryModel: serviceEntryModel }));
                } },
                React.createElement("i", { className: "fe fe-eye" }),
                " ",
                React.createElement(FormattedMessage, { id: "page.service.entries.view" }))));
}
AssetServiceEntryRow.defaultProps = {
    className: ''
};
